"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pinnedContentTypeOptions = exports.initialValues = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _PinnedContentSection = _interopRequireDefault(require("./PinnedContentSection"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/*
Structure of pinnedContent is
 1. top level
 2. module index
 3. surveyHandle

 For example:
 {
    topLevel: [
        {
            type: "",
            content: "",
        }
    ],

    0: [
        topLevel: {
            type: "",
            content: "",
        },

        survey1: [
            {
                type: "",
                content: "",
            },
            ...
        ],

        survey2: [
            {
                type: "",
                content: "",
            },
            ...
        ],
    ],

    1: [
        ...
    ],
 }
*/
var initialValues = exports.initialValues = {
  pinnedContent: {
    topLevel: []
  }
};
var pinnedContentTypeOptions = exports.pinnedContentTypeOptions = {
  bookmark: 'Bookmark',
  link: 'Link',
  resource: 'Resource',
  wysiwyg: 'WYSIWYG'
};
var Pinned = function Pinned(props) {
  var values = props.formikBag.values;
  var prefix = values.currentPrefix;
  var currValues = (0, _get2["default"])(values, prefix, {});
  var currentPinnedContent = (0, _get2["default"])(currValues, 'pinnedContent', {}) || {};
  var currentModules = (0, _get2["default"])(currValues, 'modules', []) || [];
  function getSummary(pinnedValue) {
    var summaryCounts = pinnedValue.reduce(function (totalSummary, curr) {
      if (!totalSummary[curr.type]) {
        totalSummary[curr.type] = 0;
      }
      totalSummary[curr.type]++;
      return totalSummary;
    }, {});
    var summary = Object.keys(summaryCounts).map(function (type) {
      return summaryCounts[type] + ' ' + pinnedContentTypeOptions[type];
    }).join(', ');
    return summary;
  }
  function packageSections() {
    var sections = [];
    var topLevelContent = currentPinnedContent.topLevel;

    // top-level
    sections.push({
      title: 'Top of Page',
      summary: getSummary(topLevelContent),
      content: topLevelContent,
      moduleIndex: null,
      surveyHandle: null
    });

    // module-level
    currentModules.sort(function (a, b) {
      return parseInt(a.id, 10) - parseInt(b.id, 10);
    }).forEach(function (module, moduleIndex) {
      var moduleContent = currentPinnedContent[moduleIndex].topLevel;
      sections.push({
        title: "Module ".concat(moduleIndex + 1),
        summary: getSummary(moduleContent),
        content: moduleContent,
        moduleIndex: moduleIndex,
        surveyHandle: null
      });
      module.surveyHandles.forEach(function (surveyHandle, lessonIndex) {
        var lessonContent = currentPinnedContent[moduleIndex][surveyHandle];
        sections.push({
          title: "Module ".concat(moduleIndex + 1, " - Lesson ").concat(lessonIndex + 1),
          summary: getSummary(lessonContent),
          content: lessonContent,
          moduleIndex: moduleIndex,
          surveyHandle: surveyHandle
        });
      });
    });
    return sections;
  }
  var sections = packageSections();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "Expand a section below to pin content to the specified location on this dashboard."), sections.map(function (data, i) {
    return /*#__PURE__*/_react["default"].createElement(_PinnedContentSection["default"], _extends({
      key: i
    }, data, props));
  }));
};
var _default = exports["default"] = Pinned;